<template>
<!-- This example requires Tailwind CSS v2.0+ -->
<div class="fixed z-10 inset-0 overflow-y-auto" :class="showModal?'':'hidden'" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

    <!-- This element is to trick the browser into centering the modal contents. -->
    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

    <div class="inline-block align-bottom bg-gray-700 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">

        <div class="bg-gray-700 px-4 pt-5 pb-4 sm:pb-4">
            <div class="mt-3 text-center sm:mt-0 sm:text-left">
                <h3 class="text-lg uppercase text-3xl font-bold font-medium text-white mb-1">
                Delete Provider
                </h3>

                <div class="mb-4">
                    <label class="block text-white text-lg font-bold mb-2 font-bold">
                    Please choose another provider for reasign tours
                    </label>
                    <select v-model="deleteProviderForm.new_provider_id">
                        <option :key="provider.id" v-for="provider in providers" :value="provider.id">{{ provider.name }}</option>
                    </select>
                 </div>

                <div class="mt-4 mb-4">
                 <button label="Delete" :clickFunc="deleteProvider"></button>
                  <button label="Cancel" :clickFunc="() => toggleModal(false)"></button>
                </div>

            </div>
        </div>

    </div>
  </div>
</div>
</template>

<script>
export default {
    name: 'DeleteProviderModal',
    props: ['showModal', 'delete_provider_id', 'toggleModal'],
    data() {
        return {
            providers: [],
            deleteProviderForm: this.$inertia.form({
                delete_provider_id: null,
                new_provider_id: null,
            })
        }
    },
    watch:{
        delete_provider_id: function (newState, oldState){
            this.providers = this.$page.props.providers.data.filter(el => el.id != newState);
            this.deleteProviderForm.delete_provider_id = newState;
        }
    },
    methods: {
        deleteProvider() {
            this.deleteProviderForm.post(route('provider.delete', {provider:this.deleteProviderForm.delete_provider_id, providerToReassignTours:this.deleteProviderForm.new_provider_id}), {
              preserveScroll: true,
              onSuccess: () => this.toggleModal(false),
            })
        }
    }
}
</script>
